import { Divider } from "@mui/material";
import React, { useEffect, useState } from "react";

interface ChatDividerProps {
  setSectionRatio: (ratio: number) => void;
}

const ChatDivider: React.FC<ChatDividerProps> = ({ setSectionRatio }) => {
  const [isDragging, setIsDragging] = useState(false);

  useEffect(() => {
    const handleMouseMove = (event: MouseEvent) => {
      if (isDragging) {
        const newRatio = (event.clientX / window.innerWidth) * 100;
        // range is 30 to 70
        if (newRatio >= 30 && newRatio <= 70) {
          setSectionRatio(newRatio);
        }
      }
    };

    const handleMouseUp = () => {
      setIsDragging(false);
    };

    if (isDragging) {
      window.addEventListener("mousemove", handleMouseMove);
      window.addEventListener("mouseup", handleMouseUp);
    }

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      window.removeEventListener("mouseup", handleMouseUp);
    };
  }, [isDragging, setSectionRatio]);

  const handleDividerMouseDown = (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    event.preventDefault();
    setIsDragging(true);
  };

  return (
    <Divider
      orientation="vertical"
      flexItem
      component="div"
      onMouseDown={(event) => handleDividerMouseDown(event)}
      style={{ cursor: "col-resize", width: "8px" }}
    />
  );
};

export default ChatDivider;
